
const tabHeadingContainer = document.querySelector(".featured-collection-tab-flex");
const tabHeading = document.querySelectorAll(".featured-collection-tab-heading");
const tabContainer = document.querySelectorAll(".featured-collection-tab-container");

tabHeadingContainer.addEventListener("click", function(e) {
  const clicked = e.target.closest(".featured-collection-tab-heading");
  console.log(clicked);
  tabHeading.forEach( th => th.classList.remove("featured-collection-tab-heading--active") );
  clicked.classList.add("featured-collection-tab-heading--active");
  tabContainer.forEach( tc => tc.classList.remove("featured-collection-tab-container--active") );
  document.querySelector(`.featured-collection-tab-container-${ clicked.dataset.tab }`).classList.add("featured-collection-tab-container--active");
});